import { createReducer, on } from '@ngrx/store';
import { setXAxisMetric } from './x-axis-metric.actions';
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
export const xAxisMetric = createReducer('', on(setScatterPlot, (state, action) => {
    return action.scatterPlot.xAxisMetric;
}), on(setXAxisMetric, (state, action) => {
    return action.metricId;
}));
